export default (props) => (
  /**
   * Grid vertical fake utilizado para simular um grid vertical de mapa.
   * Encontrado na configuração do output de impressão ao ativar 'Grid de Coordenadas'.
  */
  <svg
    width={11}
    height={600}
    viewBox="0 0 11 600"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">
      {"\n\t.st0{fill:none;stroke:#5E5E5E;stroke-width:0.5;}\n"}
    </style>
    <line className="st0" x1={10.2} y1={0} x2={10.2} y2={600} />
    <line className="st0" x1={2.1} y1={0.3} x2={10.1} y2={0.3} />
    <line className="st0" x1={2.1} y1={85.9} x2={10.1} y2={85.9} />
    <line className="st0" x1={2.1} y1={171.5} x2={10.1} y2={171.5} />
    <line className="st0" x1={2.1} y1={257.2} x2={10.1} y2={257.2} />
    <line className="st0" x1={2.1} y1={342.8} x2={10.1} y2={342.8} />
    <line className="st0" x1={2.1} y1={428.5} x2={10.1} y2={428.5} />
    <line className="st0" x1={2.1} y1={514.1} x2={10.1} y2={514.1} />
    <line className="st0" x1={2.1} y1={599.8} x2={10} y2={599.8} />
  </svg>
);

